const dateRanges = [
  ["today", "Today"],
  ["last_7_days", "Last 7 days"],
  ["last_30_days", "Last 30 days"],
  ["this_month", "This month"],
];

export default function AdminHeader({
  filters,
  locations,
  unreadCount,
  onFilterChange,
  onLogout,
}) {
  return (
    <header className="admin-topbar">
      <input
        placeholder="Search orders, customers, menu items"
        value={filters.search || ""}
        onChange={(event) => {
          onFilterChange({ search: event.target.value });
        }}
      />

      <select
        value={filters.location || ""}
        onChange={(event) => {
          onFilterChange({ location: event.target.value });
        }}
      >
        <option value="">All locations</option>
        {locations.map((location) => (
          <option key={location.id} value={location.id}>
            {location.name}
          </option>
        ))}
      </select>

      <select
        value={filters.range || "today"}
        onChange={(event) => {
          onFilterChange({ range: event.target.value });
        }}
      >
        {dateRanges.map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>

      <button className="btn btn-light admin-bell" aria-label="Notifications">
        <span aria-hidden="true">*</span>
        <span>{unreadCount}</span>
      </button>

      <button className="btn btn-secondary" onClick={onLogout}>
        Sign out
      </button>
    </header>
  );
}